import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { PaidFeature, PaidFeatureScope, SubscriptionPlan } from '../../../projects/client';
import { DemoSettingsState } from './demo-settings.state';
import { DemoSettingsActions } from './demo-settings.actions';
import { DemoDeviceSerials } from './demo-settings.model';

const initDemoSettingsState: DemoSettingsState = {
  subscriptionWithPaidFeatures: [
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitocal222,
    },
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitocal252a,
    },
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitodens300,
    },
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitocal200,
    },
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitovalor,
    },
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitocharge,
    },
    {
      plan: SubscriptionPlan.Pro,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.AutomatedRecommendations,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.HEMS,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.PermanentInspection,
        PaidFeature.PredictiveMaintenance,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.VitoairFS,
    },
    {
      plan: SubscriptionPlan.Plus,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitodens100opentherm,
    },
    {
      plan: SubscriptionPlan.Plus,
      scope: PaidFeatureScope.device,
      features: [
        PaidFeature.Analytics,
        PaidFeature.Dashboard,
        PaidFeature.DataRecorderAndDataTrending,
        PaidFeature.Equipment,
        PaidFeature.EventHistory,
        PaidFeature.ExtendedParameters,
        PaidFeature.Features,
        PaidFeature.GuidedTroubleshooting,
        PaidFeature.LiveUpdates,
        PaidFeature.Mails,
        PaidFeature.Monetization,
        PaidFeature.ParameterComparison,
        PaidFeature.Reports,
        PaidFeature.SmartNotes,
        PaidFeature.SystemOverview,
        PaidFeature.UserManagement,
        PaidFeature.ViguideDefaultAccess,
      ],
      resourceId: DemoDeviceSerials.Vitocal252MPK,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitodens200WMaintenance,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitodens200W,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitodens300W,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitodens343F,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitocal200Error,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitocal200Offline,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.VitovalorError,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.VitochargeV2Lag,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.VitochargeVX3,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.ViAir300,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.ViAir300F,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitoligno300C,
    },
    {
      plan: null,
      scope: PaidFeatureScope.device,
      features: [],
      resourceId: DemoDeviceSerials.Vitocal250A,
    },
  ],
};

export const demoSettingsReducer: ActionReducer<DemoSettingsState, Action> = createReducer(
  initDemoSettingsState,
  on(
    DemoSettingsActions.removeDemoConfig,
    (state): DemoSettingsState => ({
      ...state,
      subscriptionWithPaidFeatures: initDemoSettingsState.subscriptionWithPaidFeatures,
    })
  ),
  on(
    DemoSettingsActions.addFeatures,
    (state, { resourceId, features }): DemoSettingsState => ({
      ...state,
      subscriptionWithPaidFeatures: state.subscriptionWithPaidFeatures.map(
        (subscriptionWithPaidFeature) => {
          if (subscriptionWithPaidFeature.resourceId === resourceId) {
            return {
              ...subscriptionWithPaidFeature,
              features: [...new Set(subscriptionWithPaidFeature.features.concat(features))],
            };
          }

          return subscriptionWithPaidFeature;
        }
      ),
    })
  ),
  on(
    DemoSettingsActions.removeFeatures,
    (state, { resourceId, features }): DemoSettingsState => ({
      ...state,
      subscriptionWithPaidFeatures: state.subscriptionWithPaidFeatures.map(
        (subscriptionWithPaidFeature) => {
          if (subscriptionWithPaidFeature.resourceId === resourceId) {
            return {
              ...subscriptionWithPaidFeature,
              features: subscriptionWithPaidFeature.features.filter(
                (feature) => !features.includes(feature)
              ),
            };
          }

          return subscriptionWithPaidFeature;
        }
      ),
    })
  ),
  on(
    DemoSettingsActions.updatePlan,
    (state, { resourceId, plan }): DemoSettingsState => ({
      ...state,
      subscriptionWithPaidFeatures: state.subscriptionWithPaidFeatures.map(
        (subscriptionWithPaidFeature) => {
          if (subscriptionWithPaidFeature.resourceId === resourceId) {
            return {
              ...subscriptionWithPaidFeature,
              plan,
            };
          }

          return subscriptionWithPaidFeature;
        }
      ),
    })
  ),
  on(
    DemoSettingsActions.loadDemoConfig.success,
    (state, { selectSubscriptionWithPaidFeatures }): DemoSettingsState => ({
      ...state,
      subscriptionWithPaidFeatures: selectSubscriptionWithPaidFeatures,
    })
  )
);
